/**
 * Internal
 */
import { createReducer } from 'state/utils';
import * as actions from 'state/action-types';

export default createReducer('', {
	[actions.SWITCH_DASHBOARD_LAYOUT]: (state, action) => action.payload.layoutId,
});
